import React from 'react';

import Teaser from '../../../../components/Teaser';

import './style.scss';

const NodeStoryTeaser = ({ entity, large, labeled }) => {
  return (
    <div className="BaseTeaser NodeStoryTeaser">
      <Teaser entity={entity} large={large} labeled={labeled} type="story" showDate />
    </div>
  );
};

export default NodeStoryTeaser;
